import { usePageViews } from 'utils/analytics';
// import "./main.scss";
// TODO: move main.scss to index
export const AnalyticProvider = (props: any) => {
    //TODO: move it to features/analytic module
    const { children } = props;
    usePageViews();
    return <>{children}</>;
};
